import { applyMiddleware, legacy_createStore as createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { ENVIRONMENTS } from 'src/interfaces/enums';

import rootReducer, { IRootState } from './reducers';

type PreloadedState = IRootState | Record<string, never>;

export default function configureStore(preloadedState: PreloadedState = {}) {
  const middlewares = [thunkMiddleware];
  const middlewareEnhancer = applyMiddleware(...middlewares);

  const store = createStore(rootReducer, preloadedState, middlewareEnhancer);

  if (process.env.NODE_ENV === ENVIRONMENTS.DEVELOPMENT && module.hot) {
    module.hot.accept('./reducers', () => store.replaceReducer(rootReducer));
  }

  return store;
}
